import { render, staticRenderFns } from "./component_detection_item_pc.vue?vue&type=template&id=f89b07aa&scoped=true&"
import script from "./component_detection_item_pc.vue?vue&type=script&lang=js&"
export * from "./component_detection_item_pc.vue?vue&type=script&lang=js&"
import style0 from "./component_detection_item_pc.vue?vue&type=style&index=0&id=f89b07aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89b07aa",
  null
  
)

export default component.exports